import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import v from "./Message.js";
import { messageProps as p } from "./message-props.js";
import g from "../../_internal/fade-in-expand-transition/src/FadeInExpandTransition.js";
import { defineComponent as w, onMounted as A, h as u } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as L } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const b = w({
  name: "MessageEnvironment",
  props: Object.assign(Object.assign({}, p), {
    duration: {
      type: Number,
      default: 3e3
    },
    onAfterLeave: Function,
    onLeave: Function,
    internalKey: {
      type: String,
      required: !0
    },
    // private
    onInternalAfterLeave: Function,
    // deprecated
    onHide: Function,
    onAfterHide: Function
  }),
  setup(t) {
    let n = null;
    const i = L(!0);
    A(() => {
      r();
    });
    function r() {
      const {
        duration: e
      } = t;
      e && (n = window.setTimeout(o, e));
    }
    function l(e) {
      e.currentTarget === e.target && n !== null && (window.clearTimeout(n), n = null);
    }
    function f(e) {
      e.currentTarget === e.target && r();
    }
    function o() {
      const {
        onHide: e
      } = t;
      i.value = !1, n && (window.clearTimeout(n), n = null), e && e();
    }
    function d() {
      const {
        onClose: e
      } = t;
      e && e(), o();
    }
    function c() {
      const {
        onAfterLeave: e,
        onInternalAfterLeave: a,
        onAfterHide: s,
        internalKey: m
      } = t;
      e && e(), a && a(m), s && s();
    }
    function h() {
      o();
    }
    return {
      show: i,
      hide: o,
      handleClose: d,
      handleAfterLeave: c,
      handleMouseleave: f,
      handleMouseenter: l,
      deactivate: h
    };
  },
  render() {
    return u(g, {
      appear: !0,
      onAfterLeave: this.handleAfterLeave,
      onLeave: this.onLeave
    }, {
      default: () => [this.show ? u(v, {
        content: this.content,
        type: this.type,
        icon: this.icon,
        showIcon: this.showIcon,
        closable: this.closable,
        onClose: this.handleClose,
        onMouseenter: this.keepAliveOnHover ? this.handleMouseenter : void 0,
        onMouseleave: this.keepAliveOnHover ? this.handleMouseleave : void 0
      }) : null]
    });
  }
});
export {
  b as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/message/src/MessageEnvironment.js
// module id = 1715
// module chunks = 67